import { NgModule } from '@angular/core';
import { MapLibComponent } from './map-lib.component';
import { DepartmentComponent } from './departments/department/department.component';
import { CommonModule } from '@angular/common';
import { CountryComponent } from './country/country.component';
import { Dpto05Component } from './departments/dpto05/dpto05.component';
import { Dpto47Component } from './departments/dpto47/dpto47.component';
import { Dpto54Component } from './departments/dpto54/dpto54.component';
import { Dpto50Component } from './departments/dpto50/dpto50.component';
import { Dpto68Component } from './departments/dpto68/dpto68.component';
import { Dpto63Component } from './departments/dpto63/dpto63.component';
import { Dpto70Component } from './departments/dpto70/dpto70.component';
import { Dpto73Component } from './departments/dpto73/dpto73.component';
import { Dpto76Component } from './departments/dpto76/dpto76.component';
import { Dpto85Component } from './departments/dpto85/dpto85.component';
import { Dpto86Component } from './departments/dpto86/dpto86.component';
import { Dpto66Component } from './departments/dpto66/dpto66.component';
import { Dpto08Component } from './departments/dpto08/dpto08.component';
import { Dpto17Component } from './departments/dpto17/dpto17.component';
import { Dpto19Component } from './departments/dpto19/dpto19.component';
import { Dpto27Component } from './departments/dpto27/dpto27.component';
import { Dpto23Component } from './departments/dpto23/dpto23.component';
import { Dpto41Component } from './departments/dpto41/dpto41.component';
import { Dpto25Component } from './departments/dpto25/dpto25.component';
import { Dpto88Component } from './departments/dpto88/dpto88.component';
import { Dpto91Component } from './departments/dpto91/dpto91.component';
import { Dpto96Component } from './departments/dpto96/dpto96.component';
import { Dpto81Component } from './departments/dpto81/dpto81.component';
import { Dpto44Component } from './departments/dpto44/dpto44.component';
import { Dpto15Component } from './departments/dpto15/dpto15.component';
import { Dpto11Component } from './departments/dpto11/dpto11.component';
import { Dpto18Component } from './departments/dpto18/dpto18.component';
import { Dpto13Component } from './departments/dpto13/dpto13.component';
import { Dpto20Component } from './departments/dpto20/dpto20.component';
import { Dpto53Component } from './departments/dpto53/dpto53.component';
import { Dpto97Component } from './departments/dpto97/dpto97.component';
import { Dpto99Component } from './departments/dpto99/dpto99.component';

@NgModule({
  declarations: [MapLibComponent,
    DepartmentComponent, 
    CountryComponent, 
    Dpto05Component, Dpto47Component, 
    Dpto54Component, Dpto50Component, 
    Dpto68Component, Dpto63Component, 
    Dpto70Component,
    Dpto73Component,
    Dpto76Component,
    Dpto85Component,
    Dpto86Component,
    Dpto66Component,
    Dpto08Component,
    Dpto13Component,
    Dpto15Component,
    Dpto17Component,
    Dpto19Component,
    Dpto27Component,
    Dpto23Component,
    Dpto41Component,
    Dpto25Component,
    Dpto88Component,
    Dpto91Component,
    Dpto96Component,
    Dpto81Component,
    Dpto44Component,
    Dpto11Component,
    Dpto18Component,
    Dpto20Component,
    Dpto97Component,
    Dpto99Component,
    Dpto53Component
  ],
  imports: [
    CommonModule
  ],
  exports: [MapLibComponent]
})
export class MapModule { }
